var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { lazyLoad, } from '@react-page/core';
import * as React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-types
function createPluginWithDef(_a) {
    var schema = _a.schema, controlsLayout = _a.controlsLayout, Renderer = _a.Renderer, pluginSettings = __rest(_a, ["schema", "controlsLayout", "Renderer"]);
    var Controls = lazyLoad(function () { return import('./Controls'); });
    return __assign({ Component: function (props) {
            return (React.createElement(React.Fragment, null, !props.readOnly ? (React.createElement(Controls, __assign({ controlsLayout: controlsLayout, schema: schema, Renderer: Renderer }, props))) : (React.createElement(Renderer, __assign({}, props)))));
        } }, pluginSettings);
}
function createContentPlugin(definition) {
    return function (customize) {
        if (customize) {
            return createPluginWithDef(customize(definition));
        }
        return createPluginWithDef(definition);
    };
}
export default createContentPlugin;
//# sourceMappingURL=createLayoutPlugin.js.map